import React, { useReducer } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ConfirmResetPasswordLoginTemplate from '@rexmas/rexmas-shared/lib/components/templates/login/ConfirmResetPassword';
import { useActions } from '@rexmas/rexmas-shared/lib/utils/hooks';
import {
  resetPasswordConfirm as resetPasswordConfirmAction,
  showErrors as ErrorActions,
} from '../../../redux/actions/session';
import rexIcon from '../../../img/rex-logo.svg';
import { pathLanguageCode } from '../../../conf/constants/constants';

function ResetConfirmPassword() {
  const { uidb64, token } = useParams();
  const history = useHistory();

  const [state, setState] = useReducer(
    (oldState, newState) => ({ ...oldState, ...newState }),
    {
      showPassword: false,
      showPasswordConfirmed: false,
      isLoading: false,
      isButtonActive: false,
      successfullChangePassword: false,
      password: '',
      passwordError: '',
      passwordConfirmed: '',
      passwordConfirmedError: '',
      pathRedirect: `/remuneraciones/${pathLanguageCode}/login`,
    },
  );

  const [resetPasswordConfirm, showErrors] = useActions([
    resetPasswordConfirmAction,
    ErrorActions,
  ]);

  const resetPassword = () => {
    const { password } = state;
    resetPasswordConfirm(password, uidb64, token, () => null).then((response) => {
      if (response?.mensajes != null) {
        setState({ successfullChangePassword: true });
      }
      if (typeof response === 'undefined') {
        setState({ isLoading: false });
      }
    });
  };

  const validateData = () => {
    const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]+/gm;

    let passwordError = '';
    let passwordConfirmedError = '';

    if (state.password.length < 1) {
      passwordError = 'Debe ingresar una contraseña';
    }

    if (state.passwordConfirmed.length < 1) {
      passwordConfirmedError = 'Debe ingresar una contraseña';
    }

    if (state.password !== state.passwordConfirmed
      && (state.password.length > 0 && state.passwordConfirmed.length > 0)) {
      showErrors('password_not_match');
      return false;
    }

    if (passwordError.length > 0 || passwordConfirmedError.length > 0) {
      setState({ passwordError, passwordConfirmedError });
      return false;
    }

    if (state.password === state.passwordConfirmed
      && (state.password.length > 0 && state.passwordConfirmed.length > 0)
      && !regex.test(state.password)) {
      showErrors('password_invalid_format');
      return false;
    }

    return true;
  };

  const activedSendButton = () => {
    const isButtonActive = (state.password !== '' && state.passwordConfirmed !== '');
    setState({ isButtonActive });
  };

  const handleFieldChange = (field) => (event) => {
    activedSendButton();
    setState({ [`${field}Error`]: '', [field]: event.target.value });
  };

  const handleShowPasswordClick = () => {
    setState({ showPassword: !state.showPassword });
  };

  const handleShowPasswordConfirmedClick = () => {
    setState({ showPasswordConfirmed: !state.showPasswordConfirmed });
  };

  const handleButtonClick = () => {
    if (!validateData()) return;
    setState({ isLoading: true });
    resetPassword();
  };

  const handleBackButtonClick = () => {
    history.push(`/remuneraciones/${pathLanguageCode}/login`);
  };

  return (
    <ConfirmResetPasswordLoginTemplate
      password={state.password}
      passwordError={state.passwordError}
      passwordConfirmed={state.passwordConfirmed}
      passwordConfirmedError={state.passwordConfirmedError}
      isPasswordShown={state.showPassword}
      isPasswordConfirmedShown={state.showPasswordConfirmed}
      onPasswordChange={handleFieldChange}
      onPasswordConfirmedChange={handleFieldChange}
      onShowPasswordClick={handleShowPasswordClick}
      onShowPasswordConfirmedClick={handleShowPasswordConfirmedClick}
      onSubmit={handleButtonClick}
      onButtonClick={handleBackButtonClick}
      isButtonActive={state.isButtonActive}
      successfullChangePassword={state.successfullChangePassword}
      isLoading={state.isLoading}
      pathRedirect={state.pathRedirect}
      logo={rexIcon}
    />
  );
}

export default ResetConfirmPassword;
